import React, { useContext, useState, useEffect } from "react";
import './Header.css';

/* React router */
import { NavLink, useLocation } from 'react-router-dom';

/* DarkMode */
import DarkMode from '../DarkMode/DarkMode';

/* Language */
import { FormattedMessage } from "react-intl";
import { langContext } from '../../context/Context';

const HeaderPage = () => {
    // Buttom language
    const idioma = useContext(langContext);
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activePage, setActivePage] = useState('');

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Set active page based on current route
        const path = location.pathname;
        if (path === '/') setActivePage('home');
        else if (path === '/about') setActivePage('about');
        else if (path === '/project') setActivePage('projects');
        else if (path === '/project-videos') setActivePage('projectVideos'); // Add this line

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location]);

    // Menu desplegable
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Close menu when clicking on a link
    const handleLinkClick = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className={`site-header ${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="header-container">
                <NavLink className="logo" to="/" onClick={handleLinkClick}>
                    <div className="logo-container">
                        <span className="logo-bracket">=</span>
                        <span className="logo-name">ARUNSINGH</span>
                        <span className="logo-bracket">=</span>
                    </div>
                </NavLink>

                <div 
                    id="menu-btn" 
                    className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <nav className={`navbar ${isMenuOpen ? 'active' : ''}`}>
                    <NavLink 
                        to="/" 
                        className={activePage === 'home' ? 'active' : ''}
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='home'
                            defaultMessage='Home'
                        />
                    </NavLink>
                    <NavLink 
                        to="/about" 
                        className={activePage === 'about' ? 'active' : ''}
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='about'
                            defaultMessage='About me'
                        />
                    </NavLink>
                    <NavLink 
                        to="/project" 
                        className={activePage === 'projects' ? 'active' : ''}
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='projects'
                            defaultMessage='Projects'
                        />
                    </NavLink>
                    <NavLink 
                        to="/project-videos" 
                        className={activePage === 'projectVideos' ? 'active' : ''}
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='projectVideos'
                            defaultMessage='Project Videos'
                        />
                    </NavLink>
                    
                    <div className="header-controls">
                        <div className="switch" id="switch">
                            <DarkMode />
                        </div>
                        <div className="language-selector">
                            <img 
                                onClick={() => {
                                    idioma.selectLanguage('en-IN');
                                    handleLinkClick();
                                }} 
                                src="https://th.bing.com/th/id/R.607b9f69862d76af04b474113c0c7ff5?rik=lfnOsbv7mhDNbQ&riu=http%3a%2f%2fupload.wikimedia.org%2fwikipedia%2fcommons%2fb%2fbc%2fFlag_of_India.png&ehk=Pk5lH0C%2fhstFahWfb15vLjtrJb3DslIU4%2fAQneo9IIM%3d&risl=&pid=ImgRaw&r=0" 
                                alt="INDIA" 
                                className="language-flag"
                                title="Switch to Hindi"
                            />
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default React.memo(HeaderPage);